<div *ngIf="configIsLoaded | async">
    <router-outlet></router-outlet>
</div>

